import React from 'react'
import './styles.scss'

export default function CheckboxRadio(props) {
  const {
    name,
    label,
    displayRequiredMark = true,
    required,
    options = [],
    direction = 'horizontal', //TODO, Check vartical styles
    optionClassName = '',
    optionLabelClassName = '',
    type = 'checkbox',
    handleOptions,
    wrapperclassname = '',
  } = props

  const changeOptionValue = (e, name) => {
    let newValues = [...options]
    let indexSearched = newValues.findIndex((element) => element.name === name)
    if (type === 'radio') {
      newValues.map((element) => (element.checked = false))
    }
    newValues[indexSearched].checked = e.target.checked
    handleOptions(newValues)
  }

  return (
    <div>
      <div className={`checkBoxContainer ${direction ? ` --${direction}` : ''}`}>
        {label ? <label>{`${label} ${displayRequiredMark && required ? '*:' : ''}`}</label> : ''}
        <div className={`optionsContainer ${direction ? ` --${direction}` : ''}`} id={name}>
          {options.map((element) => (
            <div key={element.name} className={`${wrapperclassname}`}>
              <input
                className={optionClassName}
                type={type}
                id={`${name}${element.name}`}
                name={type === 'radio' ? name : element.name}
                onChange={(e) => changeOptionValue(e, element.name)}
                defaultChecked={element.checked}
                required={required && !options.some((e) => e.checked === true)}
                value={type === 'checkbox' ? element.checked : element.value ? element.value : element.name}
              />
              <label className={`checkBoxLabel ${optionLabelClassName}`} htmlFor={`${name}${element.name}`}>
                {element.label}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div>
        {/* {!options.some((e) => e.value === true) && required ? <span className="error">{t('Requerido')}</span> : null} */}
      </div>
    </div>
  )
}
